<template>
  <no-ssr>
    <div>
      <VueHtml2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="getFileName()"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="1100px"
        ref="html2Pdf"
      >
      <section slot="pdf-content">
        <div
          class="mb15 p10 bg-cl-white">
          <div class="row mb15">
            <div class="col-xs-12 col-md-6">
              <h4 class="m0 mb5 mt5">
                {{ $t("Zgłoszenie serwisowe ") }} {{ currentComplaint.rma_number ? currentComplaint.rma_number : currentComplaint.id }}
              </h4>
            </div>
            <div class="col-xs-12 col-md-2 col-lg-1">
              <div class="col-xs-12 col-md-6">
                <VueBarcode :value="currentComplaint.rma_number ? currentComplaint.rma_number : currentComplaint.id"/>
              </div>
            </div>
          </div>
          <div class="row mb15">
            <div class="col-xs-6 col-md-6">
              <h4 class="m0 mb5 mt5">
                {{ $t("Klient ") }} {{ currentComplaint.name }}
              </h4>
            </div>
            <div class="col-xs-6 h4"> 
              <span>
                {{ currentComplaint.street }} {{ currentComplaint.house }}<span v-if="currentComplaint.flat"> {{ $t("Flat") }} {{ currentComplaint.flat }}</span>, {{ currentComplaint.postcode }} {{ currentComplaint.city }}
              </span>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-xs-6 h5">
              <p>
                {{ $t("Create date") }}:
                {{ currentComplaint.created | date("LLL", storeView) }}
              </p>
            </div>
            <div class="col-xs-6 h5">
              <p>{{ $t("Created by") }}: {{ currentComplaint.name }}</p>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-xs-6 h5">
              <p>{{ $t("RMA ") }}: {{ currentComplaint.rma_type }}</p>
            </div>
            <div class="col-xs-6 h5">
              <p>
                {{ $t("Status") }}: {{ currentComplaint.status | capitalize }}
              </p>
            </div>
          </div>
          <div class="row mb5">
            <div class="col-xs-12 h5">
              <p>
                {{ $t("Description") }}: {{ currentComplaint.description }}
              </p>
            </div>
          </div>
          <div class="row mb15">
            <div v-if="currentComplaint.rma_type === 'service'"/>
            <div v-else class="col-xs-12 h5">
              <h4>{{ $t("Complaint items") }}</h4>
              <table class="brdr-cl-bg-secondary">
                <thead>
                  <tr>
                    <th class="sans-serif lh20">
                      {{ $t("BP model") }}
                    </th>
                    <th class="sans-serif lh20">
                      {{
                        currentComplaint.rma_type === "RMA_Zwrot" ||
                        currentComplaint.rma_type === "Zwrot"
                          ? $t("Qty")
                          : $t("Printer")
                      }}
                    </th>
                    <th class="sans-serif lh20">
                      {{
                        currentComplaint.rma_type === "RMA_Zwrot" ||
                        currentComplaint.rma_type === "Zwrot"
                          ? $t("Invoice")
                          : $t("Reason")
                      }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="brdr-cl-bg-secondary"
                    v-for="item in currentComplaint.items"
                    :key="item.sku"
                  >
                    <td class="fs-medium lh15" :data-th="$t('SKU')">
                      {{ item.part_number }}
                    </td>
                    <td class="fs-medium lh15" :data-th="$t('Qty')">
                      {{
                        currentComplaint.rma_type === "RMA_Zwrot" ||
                        currentComplaint.rma_type === "Zwrot"
                          ? item.quantity
                          : item.device
                      }}
                    </td>
                    <td class="fs-medium lh15" :data-th="$t('Reason')">
                      {{
                        currentComplaint.rma_type === "RMA_Zwrot" ||
                        currentComplaint.rma_type === "Zwrot"
                          ? item.invoice
                          : item.reason
                      }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="brdr-cl-bg-secondary">
                    <td colspan="6" class="align-right">
                      <cms-block-chunk :identifier="`c_COMPLAINT_PRINTE_PDF`" default-value="<p/>"/>  
                    </td>                    
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </section>
    </VueHtml2pdf>
    </div>
  </no-ssr>
</template>

<script>

import NoSSR from 'vue-no-ssr'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk'
import VueBarcode from 'vue-barcode';
const VueHtml2pdf = () => import('vue-html2pdf')

export default {
  components: {
    CmsBlockChunk,
    VueHtml2pdf,
    VueBarcode,
    'no-ssr': NoSSR
  },
  props: {
    currentComplaint: {
      type: Object,
      default: () => ({}),
    },
  },
  beforeMount () {
    this.$bus.$on("download-pdf", () => this.downloadPdf());
  },
  computed: {
    storeView() {
      return currentStoreView();
    },
  },
  methods: {
    downloadPdf() {
      if (this.$refs.html2Pdf && typeof this.$refs.html2Pdf.generatePdf === 'function') {
        this.$refs.html2Pdf.generatePdf();
      }
    },
    getFileName() {
      let fileName = "zgloszenie_serwisowe"
      if (this.currentComplaint && this.currentComplaint.rma_number) {
        fileName = fileName + "_" + this.currentComplaint.rma_number.replaceAll('/', '_')
      }
      return fileName
    }
  },
};
</script>
<style lang="scss" scoped>
@import "~theme/css/variables/colors";
@import "~theme/css/helpers/functions/color";
$color-tertiary: color(tertiary);
$color-white-smoke: color(white-smoke);

table {
  border-collapse: collapse;
  width: 100%;

  @media (max-width: 767px) {
    border-top: none;
  }

  th,
  td {
    text-align: left;
    padding: 20px;

    &.align-right {
      text-align: right;

      @media (max-width: 767px) {
        text-align: left;
      }
    }

    @media (max-width: 1199px) {
      padding: 10px;
    }
  }

  thead {
    @media (max-width: 767px) {
      display: none;
    }
  }

  tbody {
    tr {
      @media (max-width: 767px) {
        display: block;
      }

      &:nth-child(even) {
        td {
          background-color: $color-white-smoke;
        }
      }
    }

    td {
      @media (max-width: 767px) {
        display: block;
        text-align: left;
        padding: 10px 20px;
        &:before {
          content: attr(data-th) ": ";
          font-weight: 700;
        }
      }

      &:first-child {
        @media (max-width: 767px) {
          padding: 20px 20px 10px 20px;
        }
      }

      &:last-child {
        @media (max-width: 767px) {
          padding: 10px 20px 20px 20px;
        }
      }
    }
  }

  tfoot {
    tr {
      @media (max-width: 767px) {
        display: block;
      }

      &:last-child {
        td:last-child {
          padding-bottom: 20px;
        }
      }
    }

    td {
      @media (max-width: 767px) {
        display: block;
      }

      &:first-child {
        @media (max-width: 767px) {
          font-weight: 700;
          padding: 20px 20px 5px 20px;
        }
      }

      &:last-child {
        @media (max-width: 767px) {
          padding: 5px 20px 0 20px;
        }
      }
    }
  }

  i {
    vertical-align: middle;
  }
}

a {
  &:after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: $color-tertiary;
  }

  &:hover {
    &:after {
      opacity: 0;
    }
  }
}

address {
  font-style: normal;
}

.generate-btn {
  border: 0;
  padding: 15px 25px;
  border-radius: 5px;
  color: #fff;
  background: #243b55;
  transition: 0.3s;
  text-align: center;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
  }
}
</style>
